module.exports = __webpack_public_path__ + "static/media/reportHistory.34e4808a.svg";